/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import type { ReactNode } from 'react';
import { UserPreferencesContext } from './UserPreferencesContext';
import { useUserPreferencesState } from './useUserPreferencesState';

export const UserPreferencesProvider = ({ children }: Readonly<{ children: ReactNode }>) => (
  <UserPreferencesContext value={useUserPreferencesState()}>{children}</UserPreferencesContext>
);
